module.exports = __webpack_public_path__ + "img/logo_标准@2x(1).0fb89033.png";